const message8DisplayPropertyReducer = (state = {display:"none", marginTop:"10px", marginBottom:"0"}, action) => {
	switch(action.type){
	case 'DISPLAYMESSAGE8':	
		return {display:"block", marginTop:"10px", marginBottom:"0"};
	case 'HIDEMESSAGE8':	
		return {display:"none", marginTop:"10px", marginBottom:"0"};
	default:
		return state;
	}
}

export default message8DisplayPropertyReducer;